// authErrorMessages.js
export function mapCognitoErrorToGerman(err, fallbackMessage = 'Ein Fehler ist aufgetreten') {
    if (!err) return fallbackMessage;
    if (typeof err === 'string') return err;
    const code = err.name || err.code || '';
  
    switch (code) {
      case 'NotAuthorizedException':
        return 'E-Mail oder Passwort ist falsch.';
      case 'UserNotFoundException':
        return 'Es gibt kein Konto mit dieser E-Mail-Adresse.';
      case 'UserNotConfirmedException':
        return 'Dein Konto ist noch nicht bestätigt. Bitte prüfe deine E-Mails auf den Bestätigungscode.';
      case 'UsernameExistsException':
        return 'Diese E-Mail-Adresse ist bereits registriert.';
      case 'CodeMismatchException':
        return 'Der eingegebene Code ist nicht korrekt.';
      case 'ExpiredCodeException':
        return 'Der Code ist abgelaufen. Bitte fordere einen neuen Code an.';
      case 'LimitExceededException':
      case 'TooManyFailedAttemptsException':
      case 'TooManyRequestsException':
        return 'Zu viele Versuche. Bitte warte einen Moment und versuche es erneut.';
      case 'InvalidPasswordException':
        return 'Das Passwort erfüllt nicht die Sicherheitsanforderungen.';
      case 'InvalidParameterException':
        return 'Die eingegebenen Daten sind ungültig. Bitte überprüfe deine Eingaben.';
      case 'UserAlreadyAuthenticatedException':
        return 'Du bist bereits angemeldet.';
      default:
        return typeof err?.message === 'string' ? err.message : fallbackMessage;
    }
  }